import React from "react";
import { Box as MuiBox, BoxProps as MuiBoxProps } from "@mui/material";

export interface BoxProps extends MuiBoxProps {
  children?: React.ReactNode;
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({ children, sx, component, ...props }, ref) => {
    return (
      <MuiBox
        ref={ref}
        component={component}
        {...props}
        sx={{
          ...sx,
        }}
      >
        {children}
      </MuiBox>
    );
  },
);

Box.displayName = "Box";

export default Box;
